import React, { useEffect, useState, useContext, useMemo } from "react";
import "@styles/pages/GenericPage/ThankYouPage.scss";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";

const ThankYouPage = ({ title, textList = [] }) => (
  <Box className="thank-you-page-container">
    <Typography className="title">{title}</Typography>

    {textList.map((text, idx) => (
      <Typography key={idx} className="text">
        {text}
      </Typography>
    ))}
  </Box>
);
export default ThankYouPage;
